<template>
  <div class="productIntroduce">
    <div class="recommendPage">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide class="swiper-slide" v-for="(item, index) in slideList" :key="index">
          <img :src="item.imageUrl" @click="btnClick(item.httpUrl)"/>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev gray-60-bg white-cl" slot="button-prev">
          <svg-icon iconClass="arrow-right" className="swiper-icon-left"></svg-icon>
        </div>
        <div class="swiper-button-next gray-60-bg white-cl" slot="button-next">
          <svg-icon iconClass="arrow-right" className="swiper-icon"></svg-icon>
        </div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  name: 'productIntroduce',
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    slideList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        loop: true,
        spaceBetween: 16,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true //允许分页点击跳转
        // },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  mounted() {},
  methods: {
    btnClick(link) {
      if (link.indexOf('http') > -1) {
        window.location.href = link;
      } else {
        this.$router.push(link);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.productIntroduce {
  overflow: hidden;
}
.recommendPage {
  position: relative;
}
.swiper-container .swiper-slide {
  overflow: hidden;
}
.swiper-slide {
  width: 288px !important;
  height: 150px;
  text-align: center;
  img {
    height: 100%;
    cursor: pointer;
    border-radius: 8px;
  }
  &:last-child {
    margin-right: 0 !important;
  }
}
.swiper-button-prev, .swiper-button-next {
  width: 24px;
  height: 24px;
  border-radius: 24px;
  top: 85px !important;
  &:after {
    font-size: 8px;
  }
}
.swiper-button-prev:after{
    display: none;
}
.swiper-button-next:after{
    display: none;
}
.swiper-icon, .swiper-icon-left {
  font-size: 10px;
}
.swiper-icon-left {
  transform: rotate(180deg);
}
</style>
